import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Modal from 'react-bootstrap/lib/Modal';

import {PAGE_NAMES} from '../../../pages.js';
import { saveSettings, logout } from '../../../actions/index';

import './index.less';

export class ConsentConflictModal extends React.Component {
    static displayName = 'Usersettings.CancelSaveButton.ConsentConflictModal';
    static propTypes = {
        hideConsentConflictModal: PropTypes.func,
        saveSettings: PropTypes.func,
        logout: PropTypes.func,
        t: PropTypes.func
    };

    constructor(props) {
        super(props);
    }

    /* Save consents, remove consent check from storage if any, and */
    save = () => {
        window.sessionStorage.removeItem('UserConsentChecked');
        this.props.saveSettings(PAGE_NAMES.PRIVACY);
        this.props.logout();
    };

    render() {
        const { t } = this.props;
        const accountUrl = "https://account.polar.com";
        return (
            <Modal show bsClass="consent-conflict-modal">
                <Modal.Header>
                    <Modal.Title className="consent-conflict-modal-title">
                        <span className="alert-icon"/>
                        {t(['gdpr:consents.popup.consent_needed', 'Saving unaccepted consents'])}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="consent-conflict-body">
                        <p>{t(['gdpr:settings.consents.popup.consent_needed.info', 'You\'ve withdrawn some of the mandatory consents regarding the use of your data. To use Flow you need to agree to the use of your data as described in our Privacy Notice — otherwise we can\'t offer our services to you.'])}</p>
                        <p dangerouslySetInnerHTML={{__html: t('gdpr:settings.consents.popup.manage_your_account', { '0': '<a target="_blank" href="'+accountUrl+'">'+accountUrl+'</a>'} ) }}></p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <a className="conflict-modal-link save-btn" onClick={this.save.bind(this)}>
                        {t(['gdpr:settings.save_and_sign_out', 'Save and Logout'])}
                    </a>
                    <button type="button" className="conflict-modal-button back-btn" onClick={this.props.hideConsentConflictModal}>
                        {t(['gdpr:settings.consents.popup.back_to_settings', 'Go back and review consents'])}
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

ConsentConflictModal.propTypes = {
    saveSettings: PropTypes.func
};

const mapStateToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveSettings: (name) => dispatch(saveSettings(name)),
        logout: () => dispatch(logout())
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps), translate(['gdpr'], { wait: true }))(ConsentConflictModal);




// WEBPACK FOOTER //
// ./src/UserSettings/components/CancelSaveButton/ConsentConflictModal/index.jsx